/**
 * Generado por scripts/scaffold-module.ts el 2026-07-23.
 * Rutas del módulo Contratos.
 *
 * Este archivo es auto-cargado por src/router/routes.ts via import.meta.glob.
 * NO necesitas registrarlo manualmente en ningún otro sitio.
 */
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/contratos',
    name: 'contratos.index',
    component: () => import('./views/ContratosIndex.vue'),
    meta: {
      layout: 'default',
      requiresAuth: true,
      requiresPermission: 'contratos.read',
      title: 'Contratos',
    },
  },
]

export default routes
